export const tabEnmu = {
  invite: '1',
  commission: '2'
}